import requests from 'query/http';

import * as url from "./url_helper";



// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// delete Order
export const deleteOrder = (order : any) => requests.mutate({ ...{ headers: { order } }, url: url.DELETE_ORDER, method: 'DELETE' });

// get Customers
export const getCustomers = () => requests.query({ url: url.GET_CUSTOMERS, method: 'GET' });

// add Customers
export const addNewCustomer = (customer : any) => requests.mutate({ data: customer, url: url.ADD_NEW_CUSTOMER, method: 'POST' });

// update Customers
export const updateCustomer = (customer : any) => requests.mutate({ data: customer, url: url.UPDATE_CUSTOMER, method: 'PATCH' });

// delete Customers
export const deleteCustomer = (customer : any) => requests.mutate({ ...{ headers: { customer } }, url: url.DELETE_CUSTOMER, method: 'DELETE' });

// get Sellers
export const getSellers = () => requests.query({ url: url.GET_SELLERS, method: 'GET' });

// Project
// get Project list 
export const getProjectList = () => requests.query({ url: url.GET_PROJECT_LIST, method: 'GET' });

// Tasks
// get Task
export const getTaskList = () => requests.query({ url: url.GET_TASK_LIST, method: 'GET' });

// add Task
export const addNewTask = (task : any) => requests.mutate({ data: task, url: url.ADD_NEW_TASK, method: 'POST' });

// update Task
export const updateTask = (task : any) => requests.mutate({ data: task, url: url.UPDATE_TASK, method: 'PATCH' });

// delete Task
export const deleteTask = (task : any) => requests.mutate({ ...{ headers: { task }}, url: url.DELETE_TASK, method: 'DELETE' });

// Kanban Board
export const getTasks = () => requests.query({ url: url.GET_TASKS, method: 'GET' });
export const addNewTasks = (card: any) => requests.mutate({ data: card, url: url.ADD_TASKS, method: 'POST' })
export const updateTasks = (card: any) => requests.mutate({ data: card, url: url.UPDATE_TASKS, method: 'PUT' })
export const deleteTasks = (card: any) => requests.mutate({ ...{ headers: {card} }, url: url.DELETE_TASKS, method: 'DELETE' })

// CRM
// get Contacts
export const getContacts = () => requests.query({ url: url.GET_CONTACTS, method: 'GET' });

// add Contact
export const addNewContact = (contact : any) => requests.mutate({ data: contact, url: url.ADD_NEW_CONTACT, method: 'POST' });

// update Contact
export const updateContact = (contact : any) => requests.mutate({ data: contact, url: url.UPDATE_CONTACT, method: 'PATCH' });

// delete Contact
export const deleteContact = (contact : any) => requests.mutate({ ...{ headers: { contact }}, url: url.DELETE_CONTACT, method: 'DELETE' });

// get Companies
export const getCompanies = () => requests.query({ url: url.GET_COMPANIES, method: 'GET' });

// add Companies
export const addNewCompanies = (company : any) => requests.mutate({ data: company, url: url.ADD_NEW_COMPANIES, method: 'POST' });

// update Companies
export const updateCompanies = (company : any) => requests.mutate({ data: company, url: url.UPDATE_COMPANIES, method: 'PATCH' });

// delete Companies
export const deleteCompanies = (company : any) => requests.mutate({ ...{ headers: {company}}, url: url.DELETE_COMPANIES, method: 'DELETE' });

// get Deals
export const getDeals = () => requests.query({ url: url.GET_DEALS, method: 'GET' });

// get Leads
export const getLeads = () => requests.query({ url: url.GET_LEADS, method: 'GET' });

// add Lead
export const addNewLead = (lead : any) => requests.mutate({ data: lead, url: url.ADD_NEW_LEAD, method: 'POST' });

// update Lead
export const updateLead = (lead : any) => requests.mutate({ data: lead, url: url.UPDATE_LEAD, method: 'PATCH' });

// delete Lead
export const deleteLead = (lead : any) => requests.mutate({ ...{ headers: {lead}}, url: url.DELETE_LEAD, method: 'DELETE' });

// Crypto
// Transation
export const getTransationList = () => requests.query({ url: url.GET_TRANSACTION_LIST, method: 'GET' });

// Order List
export const getOrderList = () => requests.query({ url: url.GET_ORDRER_LIST, method: 'GET' });

// Invoice
//get Invoice
export const getInvoices = () => requests.query({ url: url.GET_INVOICES, method: 'GET' });

// add Invoice
export const addNewInvoice = (invoice : any) => requests.mutate({ data: invoice, url: url.ADD_NEW_INVOICE, method: 'POST' });

// update Invoice
export const updateInvoice = (invoice : any) => requests.mutate({ data: invoice, url: url.UPDATE_INVOICE + '/' + invoice._id, method: 'PATCH' });

// delete Invoice
export const deleteInvoice = (invoice : any) => requests.mutate({ url: url.DELETE_INVOICE + '/' + invoice, method: 'DELETE' });

// Support Tickets 
// Tickets
export const getTicketsList = () => requests.query({ url: url.GET_TICKETS_LIST, method: 'GET' });

// add Tickets 
export const addNewTicket = (ticket : any) => requests.mutate({ data: ticket, url: url.ADD_NEW_TICKET, method: 'POST' });

// update Tickets 
export const updateTicket = (ticket : any) => requests.mutate({ data: ticket, url: url.UPDATE_TICKET, method: 'PATCH' });

// delete Tickets 
export const deleteTicket = (ticket : any) => requests.mutate({ ...{ headers: {ticket}}, url: url.DELETE_TICKET, method: 'DELETE' });

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => requests.query({ url: url.GET_ALL_DATA, method: 'GET' });
export const getHalfYearlyData = () => requests.query({ url: url.GET_HALFYEARLY_DATA, method: 'GET' });
export const getMonthlyData = () => requests.query({ url: url.GET_MONTHLY_DATA, method: 'GET' });

// Audiences Metrics
export const getAllAudiencesMetricsData = () => requests.query({ url: url.GET_ALLAUDIENCESMETRICS_DATA, method: 'GET' });
export const getMonthlyAudiencesMetricsData = () => requests.query({ url: url.GET_MONTHLYAUDIENCESMETRICS_DATA, method: 'GET' });
export const getHalfYearlyAudiencesMetricsData = () => requests.query({ url: url.GET_HALFYEARLYAUDIENCESMETRICS_DATA, method: 'GET' });
export const getYearlyAudiencesMetricsData = () => requests.query({ url: url.GET_YEARLYAUDIENCESMETRICS_DATA, method: 'GET' });

// Users by Device
export const getTodayDeviceData = () => requests.query({ url: url.GET_TODAYDEVICE_DATA, method: 'GET' });
export const getLastWeekDeviceData = () => requests.query({ url: url.GET_LASTWEEKDEVICE_DATA, method: 'GET' });
export const getLastMonthDeviceData = () => requests.query({ url: url.GET_LASTMONTHDEVICE_DATA, method: 'GET' });
export const getCurrentYearDeviceData = () => requests.query({ url: url.GET_CURRENTYEARDEVICE_DATA, method: 'GET' });

// Audiences Sessions by Country
export const getTodaySessionData = () => requests.query({ url: url.GET_TODAYSESSION_DATA, method: 'GET' });
export const getLastWeekSessionData = () => requests.query({ url: url.GET_LASTWEEKSESSION_DATA, method: 'GET' });
export const getLastMonthSessionData = () => requests.query({ url: url.GET_LASTMONTHSESSION_DATA, method: 'GET' });
export const getCurrentYearSessionData = () => requests.query({ url: url.GET_CURRENTYEARSESSION_DATA, method: 'GET' });

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => requests.query({ url: url.GET_TODAYBALANCE_DATA, method: 'GET' });
export const getLastWeekBalanceData = () => requests.query({ url: url.GET_LASTWEEKBALANCE_DATA, method: 'GET' });
export const getLastMonthBalanceData = () => requests.query({ url: url.GET_LASTMONTHBALANCE_DATA, method: 'GET' });
export const getCurrentYearBalanceData = () => requests.query({ url: url.GET_CURRENTYEARBALANCE_DATA, method: 'GET' });

// Dial Type
export const getTodayDealData = () => requests.query({ url: url.GET_TODAYDEAL_DATA, method: 'GET' });
export const getWeeklyDealData = () => requests.query({ url: url.GET_WEEKLYDEAL_DATA, method: 'GET' });
export const getMonthlyDealData = () => requests.query({ url: url.GET_MONTHLYDEAL_DATA, method: 'GET' });
export const getYearlyDealData = () => requests.query({ url: url.GET_YEARLYDEAL_DATA, method: 'GET' });

// Sales Forecast
export const getOctSalesData = () => requests.query({ url: url.GET_OCTSALES_DATA, method: 'GET' });
export const getNovSalesData = () => requests.query({ url: url.GET_NOVSALES_DATA, method: 'GET' });
export const getDecSalesData = () => requests.query({ url: url.GET_DECSALES_DATA, method: 'GET' });
export const getJanSalesData = () => requests.query({ url: url.GET_JANSALES_DATA, method: 'GET' });

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => requests.query({ url: url.GET_ALLREVENUE_DATA, method: 'GET' });
export const getMonthRevenueData = () => requests.query({ url: url.GET_MONTHREVENUE_DATA, method: 'GET' });
export const getHalfYearRevenueData = () => requests.query({ url: url.GET_HALFYEARREVENUE_DATA, method: 'GET' });
export const getYearRevenueData = () => requests.query({ url: url.GET_YEARREVENUE_DATA, method: 'GET' });


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => requests.query({ url: url.GET_BTCPORTFOLIO_DATA, method: 'GET' });
export const getUsdPortfolioData = () => requests.query({ url: url.GET_USDPORTFOLIO_DATA, method: 'GET' });
export const getEuroPortfolioData = () => requests.query({ url: url.GET_EUROPORTFOLIO_DATA, method: 'GET' });

// Market Graph
export const getAllMarketData = () => requests.query({ url: url.GET_ALLMARKETDATA_DATA, method: 'GET' });
export const getYearMarketData = () => requests.query({ url: url.GET_YEARMARKET_DATA, method: 'GET' });
export const getMonthMarketData = () => requests.query({ url: url.GET_MONTHMARKET_DATA, method: 'GET' });
export const getWeekMarketData = () => requests.query({ url: url.GET_WEEKMARKET_DATA, method: 'GET' });
export const getHourMarketData = () => requests.query({ url: url.GET_HOURMARKET_DATA, method: 'GET' });

// Dashboard Project
// Project Overview
export const getAllProjectData = () => requests.query({ url: url.GET_ALLPROJECT_DATA, method: 'GET' });
export const getMonthProjectData = () => requests.query({ url: url.GET_MONTHPROJECT_DATA, method: 'GET' });
export const gethalfYearProjectData = () => requests.query({ url: url.GET_HALFYEARPROJECT_DATA, method: 'GET' });
export const getYearProjectData = () => requests.query({ url: url.GET_YEARPROJECT_DATA, method: 'GET' });

// Project Status
export const getAllProjectStatusData = () => requests.query({ url: url.GET_ALLPROJECTSTATUS_DATA, method: 'GET' });
export const getWeekProjectStatusData = () => requests.query({ url: url.GET_WEEKPROJECTSTATUS_DATA, method: 'GET' });
export const getMonthProjectStatusData = () => requests.query({ url: url.GET_MONTHPROJECTSTATUS_DATA, method: 'GET' });
export const getQuarterProjectStatusData = () => requests.query({ url: url.GET_QUARTERPROJECTSTATUS_DATA, method: 'GET' });

// dashboard job
export const getApplicationsStatistic = (roomId : any) => requests.query({ params: roomId, url: url.GET_JOBAPPLICATIONSTATISTIC, method: 'GET' });

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => requests.query({ url: url.GET_ALLMARKETPLACE_DATA, method: 'GET' });
export const getMonthMarketplaceData = () => requests.query({ url: url.GET_MONTHMARKETPLACE_DATA, method: 'GET' });
export const gethalfYearMarketplaceData = () => requests.query({ url: url.GET_HALFYEARMARKETPLACE_DATA, method: 'GET' });
export const getYearMarketplaceData = () => requests.query({ url: url.GET_YEARMARKETPLACE_DATA, method: 'GET' });

// Project
export const addProjectList = (project : any) => requests.mutate({ data: project, url: url.ADD_NEW_PROJECT, method: 'POST' });
export const updateProjectList = (project : any) => requests.mutate({ data: project, url: url.UPDATE_PROJECT, method: 'PUT' });
export const deleteProjectList = (project : any) => requests.mutate({ ...{ headers: { project } }, url: url.DELETE_PROJECT, method: 'DELETE' });

// Pages > Team
export const getTeamData = () => requests.query({ url: url.GET_TEAMDATA, method: 'GET' });
export const deleteTeamData = (team : any) => requests.mutate({ ...{ headers: { team } }, url: url.DELETE_TEAMDATA, method: 'DELETE' });
export const addTeamData = (team : any) => requests.mutate({ data: team, url: url.ADD_NEW_TEAMDATA, method: 'POST' });
export const updateTeamData = (team : any) => requests.mutate({ data: team, url: url.UPDATE_TEAMDATA, method: 'PUT' });

// File Manager

// Folder
export const getFolders = () => requests.query({ url: url.GET_FOLDERS, method: 'GET' });
export const deleteFolder = (folder : any) => requests.mutate({ ...{ headers: { folder } }, url: url.DELETE_FOLDER, method: 'DELETE' });
export const addNewFolder = (folder : any) => requests.mutate({ data: folder, url: url.ADD_NEW_FOLDER, method: 'POST' });
export const updateFolder = (folder : any) => requests.mutate({ data: folder, url: url.UPDATE_FOLDER, method: 'PUT' });

// File
export const getFiles = () => requests.query({ url: url.GET_FILES, method: 'GET' });
export const deleteFile = (file : any) => requests.mutate({ ...{ headers: { file } }, url: url.DELETE_FILE, method: 'DELETE' });
export const addNewFile = (file : any) => requests.mutate({ data: file, url: url.ADD_NEW_FILE, method: 'POST' });
export const updateFile = (file : any) => requests.mutate({ data: file, url: url.UPDATE_FILE, method: 'PUT' });

// To Do
export const getTodos = () => requests.query({ url: url.GET_TODOS, method: 'GET' });
export const deleteTodo = (todo : any) => requests.mutate({ ...{ headers: { todo } }, url: url.DELETE_TODO, method: 'DELETE' });
export const addNewTodo = (todo : any) => requests.mutate({ data: todo, url: url.ADD_NEW_TODO, method: 'POST' });
export const updateTodo = (todo : any) => requests.mutate({ data: todo, url: url.UPDATE_TODO, method: 'PUT' });

// To do Project
export const getProjects = () => requests.query({ url: url.GET_PROJECTS, method: 'GET' });
export const addNewProject = (project : any) => requests.mutate({ data: project, url: url.ADD_NEW_TODO_PROJECT, method: 'POST' });

//API Key
export const getAPIKey = () => requests.query({ url: url.GET_API_KEY, method: 'GET' });

//Job Application
export const getJobApplicationList = () => requests.query({ url: url.GET_APPLICATION_LIST, method: 'GET' });
export const addNewJobApplicationList = (job: any) => requests.mutate({ data: job, url: url.ADD_NEW_APPLICATION_LIST, method: 'POST' });
export const updateJobApplicationList = (job: any) => requests.mutate({ data: job, url: url.UPDATE_APPLICATION_LIST, method: 'PUT' });
export const deleteJobApplicationList = (job: any) => requests.mutate({ ...{ headers: { job } }, url: url.DELETE_APPLICATION_LIST, method: 'DELETE' });

// candidate list
export const getJobCandidateList = () => requests.query({ params: '', url: url.GET_CANDIDATE, method: 'GET' });
export const addJobCandidate = (candidate : any) => requests.mutate({ data: candidate, url: url.ADD_NEW_CANDIDATE, method: 'POST' });
export const updateJobCandidate = (candidate : any) => requests.mutate({ data: candidate, url: url.UPDATE_CANDIDATE, method: 'PATCH' });
export const deleteJobCandidate = (candidate : any) => requests.mutate({ ...{ headers: {candidate} }, url: url.DELETE_CANDIDATE, method: 'DELETE' });

// category list
export const getcategoryList = () => requests.query({ url: url.GET_CATEGORY_LIST, method: 'GET' });
export const addcategoryList = (category : any) => requests.mutate({ data: category, url: url.ADD_CATEGORY_LIST, method: 'POST' });

// grid
export const getCandidateGrid = () => requests.query({ url: url.GET_CANDIDATE_GRID, method: 'GET' });
export const addCandidateGrid = (category : any) => requests.mutate({ data: category, url: url.ADD_CANDIDATE_GRID, method: 'POST' });

// co2
// Login Method
export const loginEmail = (data: any) => requests.mutate({ data: data, url: url.LOGIN, method: 'POST' });
export const sendMobileOtp = (data: any) => requests.mutate({ data: data, url: url.RESEND_MOBILE_OTP, method: 'POST' });
export const checkPasscodeLogin = (data: any) => requests.mutate({ data: data, url: url.CHECK_PASSCODE_LOGIN, method: 'POST' });
export const cancelLogin = (data: any) => requests.mutate({ data: data, url: url.CANCEL_LOGIN, method: 'POST' });

// Register
export const registerEmail = (data: any) => requests.mutate({ data: data, url: url.REGISTER(window.location.pathname), method: 'POST' });
export const checkEmailVerification = (data: any) => requests.mutate({ data: data, url: url.CHECK_EMAIL_VERIFICATION(window.location.pathname), method: 'POST' });
export const checkMobileVerification = (data: any) => requests.mutate({ data: data, url: url.CHECK_MOBILE_VERIFICATION(window.location.pathname), method: 'POST' });
export const updateAccountType = (data: any) => requests.mutate({ data: data, url: url.ACCOUNT_TYPE(window.location.pathname), method: 'POST' });
export const registerBusiness = (data: any) => requests.mutate({ data: data, url: url.REGISTER_BUSINESS(window.location.pathname), method: 'POST' });
export const registerSite = (data: any) => requests.mutate({ data: data, url: url.REGISTER_SITE(window.location.pathname), method: 'POST' });
export const registerAdminUser = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.REGISTER_ADMIN_USER(window.location.pathname), method: 'POST' });
export const onCancel = (data: any) => requests.mutate({ data: data, url: url.ON_CANCEL(window.location.pathname), method: 'POST' });
export const cancelRegistration = (data: any) => requests.mutate({ data: data, url: url.CANCEL_REGISTRATION(window.location.pathname), method: 'POST' });
export const onSkip = (data: any) => requests.mutate({ data: data, url: url.ON_SKIP(window.location.pathname), method: 'POST' });
export const onBack = (data: any) => requests.mutate({ data: data, url: url.ON_BACK(window.location.pathname), method: 'POST' });
export const getAction = (data: any) => requests.mutate({ data: data, url: url.GET_ACTION(window.location.pathname), method: 'POST' });
export const checkUserRegistrationStatus = (data: any) => requests.query({ params: data, url: url.REGISTRATION_STATUS(window.location.pathname), method: 'GET' });
export const licensePlansGet = (data: any) => requests.query({ data: data, url: url.LICENSE_PLAN_GET, method: 'POST' });
export const getTokenTopUpPlans = () => requests.query({ data: {}, url: url.TOKEN_TOP_UP_PLANS_GET, method: 'POST' });
export const previewTokenTopUp = (data: { plan_id: number }) => requests.query({ data: data, url: url.TOKEN_TOP_UP_PREVIEW, method: 'POST' });
export const purchaseTokenTopUp = (data: { plan_id: number }) => requests.mutate({ data: data, url: url.TOKEN_TOP_UP_PURCHASE, method: 'POST' });
export const getTokenUsage = () => requests.query({ url: url.TOKEN_USAGE_GET, method: 'GET' });
export const getTrialSummary = () => requests.query({ url: url.LICENSE_TRIAL_SUMMARY_GET, method: 'GET' });
export const updateTokenAutoTopUp = (data: {
    enabled: boolean;
    auto_top_up_token_balance?: number;
    auto_top_up_plan_code?: string | null;
}) => requests.mutate({ data: data, url: url.TOKEN_AUTO_TOP_UP, method: 'POST' });
export const addAdminTokenCredit = (data: any) => requests.mutate({ data: data, url: url.ADMIN_TOKEN_TRANSACTIONS_CREATE, method: 'POST' });
export const licensePlanCalculate = (data: any) => requests.mutate({ data: data, url: url.LICENSE_PLAN_CALCULATE(window.location.pathname), method: 'POST' });
export const licensePlanCreate = (data: any) => requests.mutate({ data: data, url: url.LICENSE_PLAN_CREATE(window.location.pathname), method: 'POST' });
export const applyLicenseVoucher = (data: any) => requests.mutate({ data: data, url: url.LICENSE_VOUCHER_APPLY(window.location.pathname), method: 'POST' });
export const clearLicenseVoucher = (data: any) => requests.mutate({ data: data, url: url.LICENSE_VOUCHER_CLEAR(window.location.pathname), method: 'POST' });
export const processPayment = (data: any) => requests.mutate({ data: data, url: url.PROCESS_PAYMENT, method: 'POST' });
export const createStripeCustomerPortal = (data: any) => requests.mutate({ data: data, url: url.STRIPE_CUSTOMER_PORTAL, method: 'POST' });
export const getStripeCheckoutSuccess = (sessionId?: string) => requests.query({ url: url.STRIPE_CHECKOUT_SUCCESS + (sessionId ? `?session_id=${sessionId}` : ''), method: 'GET' });

// In-app subscription management
export const createStripeSubscription = (data: any) => requests.mutate({ data: data, url: url.STRIPE_CREATE_SUBSCRIPTION, method: 'POST' });
export const getStripeSubscription = () => requests.query({ url: url.STRIPE_GET_SUBSCRIPTION, method: 'GET' });
export const getLicenseRenewalDetails = (licenseId: number | string) => requests.query({ url: url.LICENSE_RENEWAL_DETAILS(licenseId), method: 'GET' });
export const previewModifyLicense = (data: any) => requests.query({ data: data, url: url.LICENSE_MODIFY_PREVIEW, method: 'POST' });
export const commitModifyLicense = (data: any) => requests.mutate({ data: data, url: url.LICENSE_MODIFY_COMMIT, method: 'POST' });
export const previewChangePlan = (data: any) => requests.query({ data: data, url: url.LICENSE_CHANGE_PLAN_PREVIEW, method: 'POST' });
export const commitChangePlan = (data: any) => requests.mutate({ data: data, url: url.LICENSE_CHANGE_PLAN_COMMIT, method: 'POST' });
export const addStripePaymentMethod = (data: { paymentMethodId: string; card_details?: string }) => requests.mutate({ data: data, url: url.STRIPE_ADD_PAYMENT_METHOD, method: 'POST' });
export const removeStripePaymentMethod = (data: {
    disable_auto_renew?: boolean;
    cancel_pending_payments?: boolean;
}) => requests.mutate({ data: data, url: url.STRIPE_REMOVE_PAYMENT_METHOD, method: 'POST' });
export const finalizeZeroAmountSubscription = (data: { setupIntentId: string; licenseId: number; bypassErrorHandler?: string; card_details?: string }) => requests.mutate({ data: data, url: url.STRIPE_FINALIZE_ZERO_AMOUNT, method: 'POST' });
export const checkAffiliateRegistrationStatus = () => requests.query({ url: url.CHECK_AFFILIATE_REGISTRATION_STATUS, method: 'GET' });
export const getSiteOwnershipOptions = () => requests.query({ url: url.GET_SITE_OWNERSHIP_OPTIONS(window.location.pathname), method: 'GET' });
export const verifyInvoiceEmail = (data: any) => requests.mutate({ data: data, url: url.VERIFY_INVOICE_EMAIL, method: 'POST' });
export const sendInvoiceEmailPasscode = (data: any) => requests.mutate({ data: data, url: url.SEND_INVOICE_EMAIL_PASSCODE, method: 'POST' });
export const getCloseAccountStatus = () => requests.query({ url: url.CLOSE_ACCOUNT_STATUS, method: 'GET' });
export const sendCloseAccountPasscode = () => requests.mutate({ data: {}, url: url.CLOSE_ACCOUNT_SEND_PASSCODE, method: 'POST' });
export const confirmCloseAccount = (data: { passcode: string }) => requests.mutate({ data: data, url: url.CLOSE_ACCOUNT_CONFIRM, method: 'POST' });

// Logout Method
export const logout = () => requests.query({ url: url.LOGOUT, method: 'GET' });

// User Profile
export const getUser = () => requests.query({ url: url.GET_USER, method: 'GET' });
export const updateUserProfile = (data: any) => requests.mutate({ data: data, url: url.UPDATE_USER_PROFILE, method: 'POST' });
export const uploadUserAvatar = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.UPDATE_USER_PROFILE, method: 'POST' });
export const removeUserAvatar = (data: any) => requests.mutate({ data: data, url: url.REMOVE_USER_AVATAR, method: 'POST' });

// Menu
export const getMenu = () => requests.query({ url: url.GET_MENU, method: 'GET' });
export const getAdminMenu = () => requests.query({ url: url.GET_ADMIN_MENU, method: 'GET' });

// Company Data
export const lookupAdvancedCompanyHouse = (data: any) => requests.mutate({ data: data, url: url.LOOKUP_ADVANCED_COMPANY_HOUSE, method: 'POST' });
export const lookupCompanyHouse = (data: any) => requests.mutate({ data: data, url: url.LOOKUP_COMPANY_HOUSE, method: 'POST' });
export const getCompanyTypes = (data: any) => requests.query({ params: data, url: url.GET_COMPANY_TYPES, method: 'GET' });
//export const addressLookup = (data: any) => api.create(url.ADDRESS_LOOKUP, data);
//export const addressGet = (data: any) => api.create(url.ADDRESS_GET, data);
export const getBusinessSites = () => requests.query({ url: url.GET_BUSINESS_SITES, method: 'GET' });
export const getBusinessDepartments = () => requests.query({ url: url.GET_BUSINESS_DEPARTMENTS, method: 'GET' });
export const getBusinessUsers = (data: any) => requests.query({ params: data, url: url.GET_BUSINESS_USERS, method: 'GET' });
export const getAdminSupportUsers = (data: any) => requests.query({ params: data, url: url.GET_ADMIN_SUPPORT_USERS, method: 'GET' });

// Dashboards
export const getBusinessDashboard = (data: any) => requests.query({ params: data, url: url.GET_BUSINESS_DASHBOARD, method: 'GET' });
export const getAffiliateDashboard = (data: any) => requests.query({ params: data, url: url.GET_AFFILIATE_DASHBOARD, method: 'GET' });

// Admin
export const getCriticalActions = () => requests.query({ url: url.GET_CRITICAL_ACTIONS, method: 'GET' });
export const checkUrlPermissions = (data: any) => requests.query({ data: data, url: url.CHECK_URL_PERMISSIONS, method: 'POST' });
export const getPageTitle = (data: any) => requests.query({ data: data, url: url.GET_PAGE_TITLE, method: 'POST' });
export const getUrlQuicklinks = (data: any) => requests.query({ data: data, url: url.GET_URL_QUICKLINKS, method: 'POST' });
export const getBusinessById = (data: any) => requests.query({ url: url.GET_BUSINESS_BY_ID(data.id), method: 'GET' });
export const getBusinessProcessActions = (data: any) => {
  const { businessId, ...params } = data;
  return requests.query({ params: params, url: url.GET_BUSINESS_PROCESS_ACTIONS(businessId), method: 'GET' });
};
export const authorizeAffiliate = (data: any) => requests.mutate({ data: data, url: url.AUTHORIZE_AFFILIATE, method: 'POST' });
export const getStatusUpdates = (data: any, options?: { isAdmin?: boolean }) =>
    requests.query({ data: data, url: options?.isAdmin ? url.STATUS_UPDATES_GET_ADMIN : url.STATUS_UPDATES_GET, method: 'POST' });
export const createStatusUpdate = (data: any, options?: { isAdmin?: boolean }) =>
    requests.mutate({ data: data, url: options?.isAdmin ? url.STATUS_UPDATES_CREATE_ADMIN : url.STATUS_UPDATES_CREATE, method: 'POST' });
export const updateStatusUpdate = (data: any, options?: { isAdmin?: boolean }) =>
    requests.mutate({ data: data, url: options?.isAdmin ? url.STATUS_UPDATES_UPDATE_ADMIN : url.STATUS_UPDATES_UPDATE, method: 'POST' });
export const deleteStatusUpdate = (data: any, options?: { isAdmin?: boolean }) =>
    requests.mutate({ data: data, url: options?.isAdmin ? url.STATUS_UPDATES_DELETE_ADMIN : url.STATUS_UPDATES_DELETE, method: 'POST' });
export const approveVAT = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.APPROVE_VAT, method: 'POST' });
export const uploadAffiliateAgreement = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.UPLOAD_AFFILIATE_AGREEMENT, method: 'POST' });
export const confirmAffiliateBankPayment = (data: any) => requests.mutate({ data: data, url: url.CONFIRM_AFFILIATE_BANK_PAYMENT, method: 'POST' });
export const cancelAffiliateApplication = (data: any) => requests.mutate({ data: data, url: url.CANCEL_AFFILIATE_APPLICATION, method: 'POST' });

//list
export const getList = (data: any) => requests.query({ data: data, url: url.GET_LIST(data.path), method: 'POST' });
export const getExport = (data: any) => requests.mutate({ data: { ...data, export: 'csv' }, url: url.GET_LIST(data.path), method: 'POST', responseType: 'blob', unwrap: false, invalidateQueries: false });
export const createObject = (data: FormData) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.CREATE_OBJECT(data.get('path') as string), method: 'POST' });
export const editObject = (data: FormData) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.EDIT_OBJECT(data.get('path') as string), method: 'POST' });
export const deleteObject = (data: any) => requests.mutate({ data: data, url: url.DELETE_OBJECT(data.path), method: 'POST' });
export const bulkDeleteObjects = (data: any) => requests.mutate({ data: data, url: url.BULK_DELETE_OBJECTS(data.path), method: 'POST' });
export const closeChat = (data: any) => requests.mutate({ data: data, url: url.CLOSE_CHAT(data.path), method: 'POST' });
export const openChat = (data: any) => requests.mutate({ data: data, url: url.OPEN_CHAT(data.path), method: 'POST' });
export const importValidation = (data: any) => requests.mutate({ data: data, url: url.IMPORT_VALIDATION(data.path), method: 'POST' });
export const importCsv = (data: any) => requests.mutate({ data: data, url: url.IMPORT_CSV(data.path), method: 'POST' });
export const importTemplate = (data: any) => requests.mutate({ data: data, url: url.IMPORT_TEMPLATE(data.path), method: 'POST', responseType: 'blob' });
export const getOptions = (data: any) => {
  const { path, ...params } = data || {};
  return requests.query({ params: Object.keys(params).length ? params : undefined, url: url.GET_OPTIONS(path), method: 'GET' });
};
export const postOptions = (data: any) => requests.query({ data: data, url: url.GET_OPTIONS(data.path), method: 'POST' });
export const getAdminNotificationAffectedUsers = (data: any) => requests.query({ data: data, url: url.ADMIN_NOTIFICATIONS_AFFECTED_USERS, method: 'POST' });
export const getNotificationsCount = () => requests.query({ url: url.GET_NOTIFICATIONS_COUNT, method: 'GET' });
export const markNotificationRead = (data: any) => requests.mutate({ data: data, url: url.MARK_NOTIFICATION_READ, method: 'POST' });
export const markNotificationUnread = (data: any) => requests.mutate({ data: data, url: url.MARK_NOTIFICATION_UNREAD, method: 'POST' });
export const updateProfileDetails = (data: any) => requests.mutate({ data: data, url: url.UPDATE_PROFILE_DETAILS(data.path), method: 'POST' });
export const cancelSupportTicket = (data: any) => requests.mutate({ data: data, url: url.CANCEL_SUPPORT_TICKET(data.path), method: 'POST' });

//business
export const updateBusiness = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.UPDATE_BUSINESS, method: 'POST' });
export const updateBusinessDefaultSettings = (data: any) => requests.mutate({ data: data, url: url.UPDATE_BUSINESS_DEFAULT_SETTINGS, method: 'POST' });
export const generateNetZeroNarrative = () => requests.mutate({ data: { bypassErrorHandler: true }, url: url.GENERATE_NET_ZERO_NARRATIVE, method: 'POST' });
export const saveNetZeroNarrative = (data: { net_zero_narrative: string; original_narrative: string | null }) => requests.mutate({ data: { ...data, bypassErrorHandler: true }, url: url.SAVE_NET_ZERO_NARRATIVE, method: 'POST' });
export const updateBusinessCarbonCommitment = (data: any) => {
  if (data instanceof FormData && !data.has('bypassErrorHandler')) {
    data.append('bypassErrorHandler', 'true');
  }

  return requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.UPDATE_BUSINESS_CARBON_COMMITMENT, method: 'POST' });
};
export const updateExtendedBusiness = (data: any) => requests.mutate({ data: data, url: url.UPDATE_EXTENDED_BUSINESS, method: 'POST' });
export const getCarbonReductionYearlyTotals = () => requests.query({ url: url.GET_CARBON_REDUCTION_YEARLY_TOTALS, method: 'GET' });
export const getCarbonReductionProjectStatusSummary = () => requests.query({ url: url.GET_CARBON_REDUCTION_PROJECT_STATUS_SUMMARY, method: 'GET' });
export const getReportCentreStats = () => requests.query({ url: url.GET_REPORT_CENTRE_STATS, method: 'GET' });
export const refreshCompanyHouse = (data: any) => requests.mutate({ data: data, url: url.REFRESH_COMPANY_HOUSE, method: 'POST' })
export const updateAffiliateDetails = (data: any) => requests.mutate({ ...{ headers: { "Content-Type": 'multipart/form-data' }}, data: data, url: url.UPDATE_AFFILIATE, method: 'POST' });

//vehicle
export const vrmLookup = (data: any) => requests.mutate({ data: data, url: url.VRM_LOOKUP, method: 'POST' });

//knowledge base
export const getKnowledgeBase = (data: any) => requests.query({ data: data, url: url.GET_KNOWLEDGE_BASE, method: 'POST' });
export const searchKnowledgeBase = (data: any) => requests.query({ data: data, url: url.SEARCH_KNOWLEDGE_BASE, method: 'POST' });
export const knowledgeBaseByCategory = (data: any) => requests.query({ data: data, url: url.KNOWLEDGE_BASE_BY_CATEGORY, method: 'POST' });
export const supportClassify = (data: any) => requests.mutate({ data: data, url: url.SUPPORT_CLASSIFY, method: 'POST' });
export const createSupportTicket = (data: any) => requests.mutate({ data: data, url: url.CREATE_SUPPORT_TICKET, method: 'POST' });
export const getKnowledgeBasePopularCategories = () => requests.query({ url: url.GET_KNOWLEDGE_BASE_POPULAR_CATEGORIES, method: 'GET' });

//activities
export const activityTypes = (params?: { reporting_year?: number; reporting_month?: number }) => requests.query({ params: params, url: url.GET_ACTIVITY_TYPES, method: 'GET' });
export const getActivitySummary = () => requests.query({ url: url.GET_ACTIVITY_SUMMARY, method: 'GET' });
export const getActivityTypesWithSubCategories = () => requests.query({ url: url.GET_ACTIVITY_TYPES_WITH_SUB_CATEGORIES, method: 'GET' });
export const getCarbonCommitmentProjectOptions = () => requests.query({ url: url.GET_CARBON_COMMITMENT_PROJECT_OPTIONS, method: 'GET' });
export const getCarbonReductionProjectActivityTypeOptions = () => requests.query({ url: url.GET_CARBON_REDUCTION_PROJECT_ACTIVITY_TYPE_OPTIONS, method: 'GET' });

//actions
export const getActionsCount = () => requests.query({ url: url.GET_ACTIONS_COUNT, method: 'GET' });
export const completeAction = (data: any) => requests.mutate({ data: data, url: url.COMPLETE_ACTION, method: 'POST' });
export const assignUserAction = (data: any) => requests.mutate({ data: data, url: url.ASSIGN_USER_ACTION, method: 'POST' });

//business setuo
export const getCurrentQuestion = (data: any = {}) => requests.mutate({ data: { ...data, is_solving_critical: true }, url: url.GET_CURRENT_QUESTION, method: 'POST' });
export const processAnswer = (data: any = {}) => requests.mutate({ data: { ...data, is_solving_critical: true }, url: url.PROCESS_ANSWER, method: 'POST' });
export const questionnaireStart = (data: any = {}) => requests.mutate({ data: { ...data, is_solving_critical: true }, url: url.QUESTIONNAIRE_START, method: 'POST' });
export const questionnaireReset = (data: any = {}) => requests.mutate({ data: { ...data, is_solving_critical: true }, url: url.QUESTIONNAIRE_RESET, method: 'POST' });
export const questionnaireAssistantMessage = (data: any = {}) => requests.mutate({ data: { ...data, is_solving_critical: true }, url: url.QUESTIONNAIRE_ASSISTANT_MESSAGE, method: 'POST' });

//activities
export const optionLookup = (data: any) => requests.query({ params: data, url: url.OPTION_LOOKUP, method: 'GET' });

/**
 * Toggle auto-renewal for a license
 */
export const toggleAutoRenewal = (data: {
    enable: boolean;
    bypassErrorHandler?: string;
}): Promise<{ success: boolean; auto_renew: boolean; auto_renewed: boolean; auto_renewal_date: string | null }> => {
    return requests.mutate({ data: data, url: url.LICENSE_TOGGLE_AUTO_RENEWAL, method: 'POST' });
};

/**
 * Get pending renewal license details
 */
export const getPendingRenewal = (params?: {
    pricingMode?: 'scheduled' | 'now';
    pricingDate?: string;
}): Promise<{
    exists: boolean;
    pendingLicense?: any;
    pricing?: any;
    paymentSplit?: {
        invoice_total?: number;
        available_balance?: number;
        balance_applied?: number;
        card_amount?: number;
    };
    pricingDate?: string;
}> => {
    const qp = new URLSearchParams();
    if (params?.pricingMode) qp.set('pricingMode', params.pricingMode);
    if (params?.pricingDate) qp.set('pricingDate', params.pricingDate);
    const queryParams = qp.toString() ? `?${qp.toString()}` : '';
    return requests.query({ url: `${url.STRIPE_PENDING_RENEWAL}${queryParams}`, method: 'GET' });
};

/**
 * Assigned user type for license assignment
 */
export interface AssignedUser {
    id: number;
    assignmentId: number;
    name: string;
    email: string;
    allocatedDate: string;
    isCurrentUser: boolean;
}

/**
 * Response type for assigned users API
 */
export interface AssignedUsersResponse {
    licenseId: number;
    licensePlanName: string;
    allowedUsers: number;
    assignedCount: number;
    availableSlots: number;
    users: AssignedUser[];
}

/**
 * Get assigned users for a license
 * @param params - licenseId to get by ID, or omit it for the current business license
 */
export const getAssignedUsers = (params: {
    licenseId?: number;
}): Promise<AssignedUsersResponse> => {
    if (params.licenseId) {
        return requests.query({ url: `/api/licenses/${params.licenseId}/users`, method: 'GET' });
    }
    return requests.query({ url: `/api/licenses/assigned-users`, method: 'GET' });
};

/**
 * Response type for remove user API
 */
export interface RemoveUserResponse {
    success: boolean;
    assignedCount: number;
    allowedUsers: number;
}

/**
 * Remove a user from a license
 * @param licenseId - The license ID
 * @param userId - The user ID to remove
 */
export const removeUserFromLicense = (
    licenseId: number,
    userId: number
): Promise<RemoveUserResponse> => {
    return requests.mutate({ url: `/api/licenses/${licenseId}/users/${userId}`, method: 'DELETE' });
};

// ==========================================
// Renewal Management API
// ==========================================

export interface RenewalPlan {
    id: number;
    name: string;
    code: string;
    planMonths: number;
    billingCycleMonths: number;
    includedUsers: number;
    includedSites: number;
    baseCost: number;
    additionalUserCost: number;
    additionalSiteCost: number;
    description?: string;
}

export interface RenewalConfigResponse {
    currentLicenseId: number;
    pendingRenewalId: number | null;
    currentPeriodEnd: string;
    minUsers: number;
    assignedUsersCount: number;
    actualSites: number;
    appliedVoucher: {
        id: number;
        code: string;
        settings: any;
        remaining_iterations: number | null;  // null = unlimited, 0 = expired, N = remaining
    } | null;
    voucherLocked: boolean;
    plans: {
        monthly: RenewalPlan[];
        annual: RenewalPlan[];
    };
    defaults: {
        planId: number | null;
        planCode: string | null;
        billingCycle: 'monthly' | 'annual';
        contractMonths?: number;
        paymentCycleMonths?: number;
        autoRenew: boolean;
        allowedUsers: number;
        allowedSites: number;
        additionalUsers: number;
        additionalSites: number;
    };
    pricingDate?: string;
}

export interface RenewalCostResponse {
    baseCost: number;
    additionalUsersCost: number;
    additionalSitesCost: number;
    subtotal: number;
    discountAmount: number;
    discountPercentage: number;
    vatRate: number;
    vatAmount: number;
    total: number;
    voucherValid: boolean;
    voucherId: number | null;
    voucherCode?: string | null;
    pricingDate?: string;
}

export interface SaveRenewalResponse {
    success: boolean;
    renewalId: number;
    isNew: boolean;
    renewal: {
        startDate: string;
        endDate: string;
        planName: string;
        totalCost: number;
    };
}

/**
 * Get renewal configuration including plans, defaults, and voucher status
 */
export const getRenewalConfig = (params?: {
    pricing_mode?: 'scheduled' | 'now';
    pricing_date?: string;
}): Promise<RenewalConfigResponse> => {
    const qp = new URLSearchParams();
    if (params?.pricing_mode) qp.set('pricing_mode', params.pricing_mode);
    if (params?.pricing_date) qp.set('pricing_date', params.pricing_date);
    const queryParams = qp.toString() ? `?${qp.toString()}` : '';
    return requests.query({ url: `/api/renewal/config${queryParams}`, method: 'GET' });
};

/**
 * Calculate renewal cost based on selected options
 * @param data - Plan selection and options for cost calculation
 */
export const calculateRenewalCost = (data: {
    plan_id: number;
    additional_users: number;
    additional_sites: number;
    voucher_code?: string;
    pricing_mode?: 'scheduled' | 'now';
    pricing_date?: string;
}): Promise<RenewalCostResponse> => {
    return requests.query({ data: data, url: '/api/renewal/calculate', method: 'POST' });
};

/**
 * Save renewal configuration (create or update pending license)
 * @param data - Complete renewal configuration to save
 */
export const saveRenewal = (data: {
    plan_id: number;
    billing_cycle: 'monthly' | 'annual';
    additional_users: number;
    additional_sites: number;
    voucher_code?: string;
}): Promise<SaveRenewalResponse> => {
    return requests.mutate({ data: data, url: '/api/renewal/save', method: 'POST' });
};

export const resetPendingRenewalToActive = (): Promise<{
    success: boolean;
    message?: string;
    renewal?: any;
}> => {
    return requests.mutate({ data: {}, url: '/api/renewal/reset', method: 'POST' });
};

/**
 * Process immediate renewal payment
 * Triggers Stripe payment for the current pending business renewal
 * @returns Promise with success status and message or error
 */
export const processRenewalNow = (data: {
    pending_license_id?: number;
    bypassErrorHandler?: string;
    card_details?: string;
}): Promise<{
    success: boolean;
    message?: string;
    error?: string;
    requiresAction?: boolean;
    clientSecret?: string | null;
    paymentIntentId?: string | null;
}> => {
    return requests.mutate({ data: data, url: '/api/renewal/process-now', method: 'POST' });
};

// data upload centre
export const getDataUploadCentreActiveCount = () => requests.query({ url: url.DATA_UPLOAD_CENTRE_ACTIVE_COUNT, method: 'GET' });
export const getDataUploadCentrePageSummary = () => requests.query({ url: url.DATA_UPLOAD_CENTRE_PAGE_SUMMARY, method: 'GET' });
export const cancelDataUploadCentre = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_CANCEL(id), method: 'POST' });
export const restartDataUploadCentre = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_RESTART(id), method: 'POST' });
export const cancelDataUploadCentres = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_UPLOAD_CENTRE_BULK_CANCEL, method: 'POST' });
export const restartDataUploadCentres = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_UPLOAD_CENTRE_BULK_RESTART, method: 'POST' });
export const rollbackDataUploadCentre = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_ROLLBACK(id), method: 'POST' });
export const skipDataUploadCentreItem = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_ITEM_SKIP(id), method: 'POST' });
export const retryMissingDataUploadCentreItem = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_ITEM_RETRY_MISSING(id), method: 'POST' });
export const skipDataUploadCentreItems = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_UPLOAD_CENTRE_ITEMS_SKIP, method: 'POST' });
export const editDataUploadCentreItem = (id: number) => requests.mutate({ data: {}, url: url.DATA_UPLOAD_CENTRE_ITEM_EDIT(id), method: 'POST' });
export const uploadDataUploadCentreFile = (data: FormData) => requests.mutate({ ...{ headers: { 'Content-Type': 'multipart/form-data' } }, data: data, url: url.DATA_UPLOAD_CENTRE_UPLOAD, method: 'POST' });

// data audit items
export const bulkRecheckDataAuditItems = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_AUDIT_ITEMS_BULK_RECHECK, method: 'POST' });
export const bulkSkipDataAuditItems = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_AUDIT_ITEMS_BULK_SKIP, method: 'POST' });
export const bulkUnskipDataAuditItems = (ids: number[]) => requests.mutate({ data: { ids }, url: url.DATA_AUDIT_ITEMS_BULK_UNSKIP, method: 'POST' });

// admin government factors
export const uploadGovernmentFactors = (id: number) => requests.mutate({ data: { id }, url: url.ADMIN_GOVERNMENT_FACTORS_UPLOAD_FACTORS, method: 'POST' });
export const getGovernmentFactorsUploadStatus = (id: number) => requests.query({ data: { id }, url: url.ADMIN_GOVERNMENT_FACTORS_UPLOAD_FACTORS_STATUS, method: 'POST' });
export const excludeGovernmentFactorsItems = (ids: number[], reason: string) =>
    requests.mutate({ data: { ids, reason }, url: url.ADMIN_GOVERNMENT_FACTORS_ITEMS_EXCLUDE, method: 'POST' });

// affiliate API keys
export type AffiliateApiKeyStatus = 'active' | 'inactive' | 'revoked';

export const createAffiliateApiKey = (name: string, affiliateBusinessId?: number, adminOverview = false) =>
    affiliateBusinessId
        ? requests.mutate<{ rawKey?: string }>({
            data: { name, parent_id: affiliateBusinessId },
            url: adminOverview ? url.ADMIN_API_KEYS_CREATE : url.ADMIN_AFFILIATE_API_KEYS_CREATE,
            method: 'POST',
        })
        : requests.mutate<{ rawKey?: string }>({
            data: { name },
            url: url.AFFILIATE_API_KEYS_CREATE,
            method: 'POST',
        });

export const updateAffiliateApiKeyStatus = (
    id: number,
    status: AffiliateApiKeyStatus,
    affiliateBusinessId?: number,
    adminOverview = false
) =>
    affiliateBusinessId
        ? requests.mutate({
            data: { status, parent_id: affiliateBusinessId },
            url: adminOverview ? url.ADMIN_API_KEY_STATUS(id) : url.ADMIN_AFFILIATE_API_KEY_STATUS(id),
            method: 'PATCH',
        })
        : requests.mutate({
            data: { status },
            url: url.AFFILIATE_API_KEY_STATUS(id),
            method: 'PATCH',
        });

export const updateAffiliateAccessSettings = (
    businessId: number,
    payload: {
        allow_affiliate_application?: boolean;
        allow_saas?: boolean;
        charge_saas_tokens?: boolean;
        saas_uplift_charge?: number;
    }
) =>
    requests.mutate<{
        allow_affiliate_application: boolean;
        allow_saas: boolean;
        charge_saas_tokens: boolean;
        saas_uplift_charge: number;
    }>({
        data: payload,
        url: url.ADMIN_AFFILIATE_SETTINGS(businessId),
        method: 'POST',
    });

export const updateAffiliateUserSaasRole = (businessId: number, userId: number, granted: boolean) =>
    requests.mutate<{ success: boolean; granted: boolean }>({
        data: { granted },
        url: url.ADMIN_AFFILIATE_USER_SAAS_ROLE(businessId, userId),
        method: 'POST',
    });

// affiliate invites
export const getAffiliateInviteAvailableVouchers = () =>
    requests.query({ url: url.AFFILIATE_SEND_INVITE_AVAILABLE_VOUCHERS, method: 'GET' });

export const getAffiliateManagerOptions = () =>
    requests.query<{ data: { value: number | string; label: string }[] }>({ url: url.GET_AFFILIATE_MANAGER_OPTIONS, method: 'GET' });

export const updateBusinessAffiliateManager = (businessId: string | number, affiliateManagerUserId: number | string | null) =>
    requests.mutate<{ affiliate_manager_user_id: number | null }>({ data: {
        affiliate_manager_user_id: affiliateManagerUserId,
    }, url: url.UPDATE_BUSINESS_AFFILIATE_MANAGER(businessId), method: 'POST' });

export const previewAffiliateInvite = (data: {
    template_id: number | string;
    marketing_code_id?: number | string | null;
    voucher_id?: number | string | null;
    recipient_name?: string;
    recipient_business_name?: string;
}) => requests.mutate<{ subject: string; body_html: string }>({ data: data, url: url.AFFILIATE_SEND_INVITE_PREVIEW, method: 'POST' });

export const sendAffiliateInvite = (data: {
    template_id: number | string;
    marketing_code_id: number | string;
    voucher_id?: number | string | null;
    subject?: string;
    recipient: { name: string; email: string; business_name?: string };
}) => requests.mutate({ data: data, url: url.AFFILIATE_SEND_INVITE_SEND, method: 'POST' });

export type EmailInviteDetails = {
    id: number;
    template_type: 'affiliate_invite' | 'customer_invite';
    template_id: number | string | null;
    marketing_code_id: number | string | null;
    voucher_id: number | string | null;
    subject: string | null;
    recipient_name: string;
    recipient_email: string;
    recipient_business_name: string | null;
};

export const getAffiliateInviteOptions = () =>
    requests.query<{ data: { value: number | string; label: string }[] }>({ url: url.AFFILIATE_INVITE_OPTIONS, method: 'GET' });

export const getEmailInvite = (id: number | string) =>
    requests.query<{ data: EmailInviteDetails }>({ url: url.EMAIL_INVITE(id), method: 'GET' });

export const setEmailInviteRegistered = (id: number | string, businessId: number | string) =>
    requests.mutate({ data: { business_id: businessId }, url: url.EMAIL_INVITE_SET_REGISTERED(id), method: 'PATCH' });

export const rejectEmailInvite = (id: number | string) =>
    requests.mutate({ data: {}, url: url.EMAIL_INVITE_REJECT(id), method: 'PATCH' });

export const retryEmailInvite = (id: number | string) =>
    requests.mutate({ data: {}, url: url.EMAIL_INVITE_RETRY(id), method: 'POST' });

export type EmailParagraphOption = { id: number; paragraph_name: string; content_html: string };
export type EmailTemplateParagraphLink = { id: number; paragraph_name: string; order_no: number; visible_condition_sql: string | null };

export const getEmailTemplateParagraphs = (templateCode: string) =>
    requests.query<{ template: any; selected: EmailTemplateParagraphLink[]; library: EmailParagraphOption[] }>({
        url: url.ADMIN_EMAIL_TEMPLATE_PARAGRAPHS(templateCode),
        method: 'GET',
    });

export const saveEmailTemplateParagraphs = (
    templateCode: string,
    paragraphs: { paragraph_name: string; visible_condition_sql?: string | null }[]
) => requests.mutate({ data: { paragraphs }, url: url.ADMIN_EMAIL_TEMPLATE_PARAGRAPHS(templateCode), method: 'POST' });

export const previewEmailTemplateParagraphs = (paragraphNames: string[]) =>
    requests.mutate<{ body_html: string }>({
        data: { paragraph_names: paragraphNames },
        url: url.ADMIN_EMAIL_TEMPLATE_PARAGRAPHS_PREVIEW,
        method: 'POST',
    });

export type EmailTemplatePlaceholder = { name: string; description: string };

export const getEmailTemplatePlaceholders = () =>
    requests.query<{ data: EmailTemplatePlaceholder[] }>({
        url: url.ADMIN_EMAIL_TEMPLATE_PLACEHOLDERS,
        method: 'GET',
        query: { staleTime: 5 * 60_000 },
    });

export const sendEmailTemplateTest = (templateCode: string, paragraphNames: string[]) =>
    requests.mutate<{ success: boolean; email: string }>({
        data: { paragraph_names: paragraphNames },
        url: url.ADMIN_EMAIL_TEMPLATE_SEND_TEST(templateCode),
        method: 'POST',
    });

export const addManualEmailInvite = (data: {
    template_type: 'affiliate_invite' | 'customer_invite';
    sent_at?: string;
    recipient: { name: string; email: string; business_name?: string };
}) => requests.mutate({ data: data, url: url.EMAIL_INVITE_ADD_MANUAL, method: 'POST' });
